import type { HTTPError } from 'ky'

class ApiError extends Error {
  statusCode: number
  code: string | number

  constructor(
    public raw: HTTPError,
    private errData: TErr
  ) {
    super(raw.message)
    this.statusCode = raw.response.status
    this.code = errData.code
  }

  getData<TData = unknown>() {
    return this.errData as TErr<TData>
  }

  static is(error: unknown): error is ApiError {
    return error instanceof ApiError
  }
}

export { ApiError }
